<!-- 竞猜规则弹窗 游戏币 -->
<template>
<el-dialog
    class="ball-style"
    :visible.sync="status"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    >
    <div class="ball-cup-container">
        <div class="title-text">竞猜规则</div>
        <div class="tag"><img :src="require('../assets/happy.png')" alt="" height="65"></div>
        <div class="close" @click="closeHandler"><img :src="require('../assets/close.png')" alt="" height="33"></div>
        <div class="rule-cont">
            <div class="rule-item">
                <div class="li-ico"><img :src="require('../assets/li-ico.png')" alt="" height="24"></div>
                <div class="cont">1、</div>
                <div class="flex-cont">
                    <div class="txt">发布原创文章，与值友们交流切磋，可获得以下金币奖励。   </div>
                    <div class="txt">【基础奖励】：认证用户获得100金币/篇；普通用户获得50金币/篇（发布至社 区频道以上可获得）</div>
                    <div class="txt">【热度奖励】：文章发至社区后，系统会统计文章96小时内产生的热度，计算出 热度奖励</div>
                    <div class="txt">详细奖励说明，详见《社区创作者激励计划&金币奖励标准》  </div>
                </div>
            </div>
            <div class="rule-item">
                <div class="li-ico"><img :src="require('../assets/li-ico.png')" alt="" height="24"></div>
                <div class="cont">2、</div>
                <div class="txt">APP端发布路径：首页右上角&#8594“+”按钮&#8594写文章</div>
                <div class="txt">【热度奖励】：文章发至社区后，系统会统计文章96小时内产生的热度，计算出 热度奖励</div>
            </div>
          
        </div>
        

    </div>
    <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
    </span> -->
</el-dialog>
</template>
<script>
export default {
    name :'GuessingRulesGold',
    props:['status'],
    data(){
        return {}
    },
    methods:{
        closeHandler(){
            this.$emit('update:status',false)
        }

    }
}
</script>
<style lang="less" scoped>
.ball-style{
    /deep/.el-dialog{width:700px; background: none;}
    /deep/.el-dialog__header{display: none;}
    /deep/.el-dialog__body{
        padding: 0;
    }
}
@media screen and (max-width:768px){
    .ball-style{

        /deep/.el-dialog{width:90%}
    }
}

.ball-cup-container{
    background: url(../assets/dialog-bg.png) no-repeat right top #ff4400; padding:20px 25px; position: relative; border-radius: 10px;
    .title-text{font-size: 28px; line-height: 40px; color: #fff; font-weight: 600; margin-bottom: 10px;}
    .tag{position: absolute; right: 75px; top: 5px;}
    .close{position: absolute; right: 25px; top: 15px; cursor: pointer;}
}

.rule-cont{
    padding: 20px; background: #fff; border-radius: 10px; 
    .rule-item{
        display: flex; font-size: 16px; line-height: 30px; color: #353535;
        .li-ico{padding-top: 3px; margin-right: 3px;}
    }
}
</style>